import React from "react";
import "./About.css";
import me from "../../assets/images/hero (1).jpg";
import { FaAward } from "react-icons/fa";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import { VscFolderLibrary } from "react-icons/vsc";

const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={me} alt="AboutImage" className="my-image" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>2+ Years Working</small>
            </article>

            <article className="about__card">
              <AiOutlineUsergroupAdd className="about__icon" />
              <h5>Clients</h5>
              <small>20+ World Wide</small>
            </article>

            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>50+ Completed</small>
            </article>
          </div>
          <p>
            As a skilled software engineer, I excel in algorithmic
            problem-solving, demonstrated by solving 530+ LeetCode challenges
            with a 1550+ rating. Proficient in C, C++, Python, Flutter and the
            MERN stack, I thrive in full-stack development. My expertise spans
            MongoDB, MySQL, and Firebase for seamless data integration. I've
            successfully integrated machine learning, developing a Face
            Recognition application and a Movie Rating Prediction model. With 4+
            internships in Flutter and MERN stack development, including a
            leadership role guiding a front-end team, I deliver robust
            applications. Proficient in Flutter, I've built 4-5 applications
            leveraging technologies like Socket.io, Firebase, and MongoDB. My
            adaptability and eagerness to learn new technologies ensure success
            in diverse, technology-driven projects.
          </p>
          <a href="#contact" className="btn btn-primary">
            {" "}
            Let's Connect
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
